/* Change category photography once per visit. Keep the native card and frame. */
(() => {
  if (window.Shopify?.designMode) return;
  const lifecycle = new AbortController();

  function initialise(root = document) {
    const rotation = window.LoveCashmereVisitRotation;
    if (typeof rotation?.choose !== 'function') return;

    root.querySelectorAll('[data-lc-category-images]').forEach((metadata) => {
      const card = metadata.closest('.collection-list__item');
      const image = card?.querySelector('.card__media img');
      if (!image) return;

      let images;
      try {
        images = JSON.parse(metadata.dataset.lcCategoryImages);
      } catch (_) {
        return;
      }
      if (!Array.isArray(images) || images.length < 2 || images.length > 3) return;
      const keys = images.map((item) => item?.src);
      if (keys.some((key) => typeof key !== 'string' || !key)) return;
      const key = rotation.choose('shop:' + metadata.dataset.lcCategoryKey, keys, keys[0]);
      const selectedIndex = keys.indexOf(key);
      if (selectedIndex < 0 || metadata.dataset.lcCategoryPrepared === key) return;
      metadata.dataset.lcCategoryPrepared = key;
      if (selectedIndex === Number(card.dataset.lcCategoryImage || '0')) return;
      const selected = images[selectedIndex];
      if (!selected || typeof selected.src !== 'string' || !selected.src ||
          typeof selected.srcset !== 'string' || !selected.srcset ||
          typeof selected.alt !== 'string') return;

      const preload = new Image();
      preload.sizes = image.sizes;
      preload.srcset = selected.srcset;
      preload.src = selected.src;
      const loaded = typeof preload.decode === 'function'
        ? preload.decode()
        : new Promise((resolve, reject) => {
            if (preload.complete) {
              preload.naturalWidth ? resolve() : reject();
            } else {
              preload.onload = resolve;
              preload.onerror = reject;
            }
          });

      loaded.then(() => {
        if (!metadata.isConnected || !image.isConnected || !preload.naturalWidth ||
            metadata.dataset.lcCategoryPrepared !== key) return;
        image.srcset = selected.srcset;
        image.src = selected.src;
        image.alt = selected.alt;
        card.dataset.lcCategoryImage = String(selectedIndex);
      }).catch(() => {
        // A missing or failed alternate must leave the original photograph intact.
      });
    });
  }

  document.addEventListener('lc:visit-change', () => initialise(), { signal: lifecycle.signal });
  window.addEventListener('pagehide', (event) => {
    if (!event.persisted) lifecycle.abort();
  }, { signal: lifecycle.signal });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
})();
